import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import navigationBarStyles from './navigationBarStyles';
import SectionNavigation, { ISectionNavigationProps } from '../sectionNavigation/SectionNavigation';
import ChangeModelLink from '../changeModelLink/ChangeModelLink';
import clsx from 'clsx';
import useSalesEnablementContext from '../../../hooks/useSalesEnablementContext';
import LocationBar from '../locationBar/LocationBar';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import useIsTablet from '../../../../common/react/useIsTablet';
import customise from '../../../../customise/constants/customise';

export interface INavigationBarProps extends ISectionNavigationProps {
  isCustomisePage?: boolean;
  promotionalLabel?: string;
}

const NavigationBar: FunctionComponent<INavigationBarProps> = ({
  items,
  onClick,
  activeItem,
  withTranslation,
  isGraphql,
  trimLabel,
  isCustomisePage,
  promotionalLabel,
}) => {
  const styles = navigationBarStyles();
  const {
    platformConfig: { isComplexModel, isDealerSelectionEnabled },
  } = usePlatformConfig();
  const { initializedWithStock } = useSalesEnablementContext();
  const isTablet = useIsTablet();

  const renderModelLinkComponent = (): React.ReactNode => {
    return (
      <Box
        className={clsx(styles.changeModelLinkContainer, { [styles.changeLinkContainerCustomize]: isCustomisePage })}
      >
        <ChangeModelLink dataTest={'navigation:link_change_model'} isGraphql={isGraphql} />
      </Box>
    );
  };

  const renderPromotionalLabel = () => (
    <Box className={styles.promotionalLabel} data-test="navigation_bar:promotionalLabel">
      <Typography>{promotionalLabel}</Typography>
    </Box>
  );

  const displayLabelOnDesktop = promotionalLabel && !isTablet;
  const displayLabelOnMobile = promotionalLabel && isTablet;

  return (
    <>
      <Box
        id={customise.NAVIGATION_BAR_ID}
        className={clsx(styles.container, { [styles.containerVariantsPage]: !isCustomisePage })}
        data-test="navigation_bar:container"
      >
        {isComplexModel && !initializedWithStock && renderModelLinkComponent()}
        <SectionNavigation
          className={styles.buttonsContainer}
          activeItem={activeItem}
          items={items}
          onClick={onClick}
          isGraphql={isGraphql}
          trimLabel={trimLabel}
          withTranslation={withTranslation || !isComplexModel}
        />
        {displayLabelOnDesktop && renderPromotionalLabel()}
      </Box>
      {displayLabelOnMobile && renderPromotionalLabel()}
      {isGraphql && isDealerSelectionEnabled && <LocationBar />}
    </>
  );
};

export default NavigationBar;
